module.exports = __webpack_public_path__ + "static/fipctransport1-3071515bb11d30231b6dc2546057f4bb.jpeg";